<template>
  <div class="md-layout px-0">
    <div
      class="md-layout md-layout-item md-large-size-60 md-medium-size-80 md-xlarge-size-50 md-size-100 px-0"
      v-if="information.length"
    >
      <div
        class="md-layout-item md-xsmall-size-50 md-small-size-50 md-size-25 flex items-center px-0"
        v-for="(item, index) in information"
        :key="item + index"
      >
        <md-card
          class="rounded-2xl mr-auto mr-auto border-1 w-[135px] h-[135px]"
        >
          <md-card-content class="mx-auto text-center flex flex-col h-full">
            <md-icon v-if="item.icon" class="text-[#2D82B5] pt-3 mb-5">
              <i :class="item.icon" class="text-[#2D82B5] text-[47px]"></i>
            </md-icon>
            <img
              v-else
              class="mx-auto w-[50px] h-[45px]"
              src="/img/time-award.svg"
              alt=""
            />
            <p class="text-[#2D82B5] pt-2 grow">
              {{ item.value }}
              {{ index === 5 ? $t("zoom_meeting.minutes") : "" }}
            </p>
            <h2>{{ $t(item.name) }}</h2>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <div class="md-layout-item md-size-65 md-layout px-0">
      <div class="md-layout md-layout-item md-size-100 px-0">
        <div
          v-for="(item, index) in general"
          :key="'info' + index"
          class="md-layout-item md-size-50 md-medium-size-100 pl-0 pr-1 pt-6"
        >
          <md-icon>{{ item.icon }}</md-icon>
          {{ $t(item.name) }} {{ $t(item.value) }}
          {{ index === 3 ? $t("zoom_meeting.minutes") : "" }}
        </div>
      </div>
    </div>
    <!--    <div class="md-layout-item px-0 max-w-[320px] pt-4 mr-3">-->
    <!--      <div class="chart-container pt-4" v-if="chartData">-->
    <!--        <div class="chart-content ">-->
    <!--          <p class="text-center text-[19px] font-medium pt-6">-->
    <!--            {{ $t("zoom_meeting.report_present") }}-->
    <!--          </p>-->
    <!--          <p class="text-center text-[19px] font-medium">{{ present }}</p>-->
    <!--        </div>-->
    <!--        <doughnut :chartData="chartData" class=" h-[300px]"></doughnut>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>
<script>
import Doughnut from "../../Components/DoughnutChart";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import {
  scheduleMeetingList,
  listCardInformation
} from "../../Components/ultils";
import { convertTimeByTimezone } from "@/helpers/datetime-helper";
const clientLocale = localStorage.getItem("language");

const formatDateClient =
  clientLocale === "en" ? "MM-DD-YYYY hh:mm A" : "DD-MM-YYYY hh:mm A";

export default {
  props: ["generalInfo", "staticInfo"],
  // components: { Doughnut },
  data() {
    return {
      chartData: null,
      information: [],
      general: null,
      present: "",
      generateWidth: ""
    };
  },
  watch: {
    generalInfo: function(newVal) {
      this.general = this.setListGeneralInfo(newVal);
    },
    staticInfo: function(newVal) {
      if (!newVal) return;
      this.setDataStatic(newVal);
    }
  },
  created() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.generateWidth = window.innerWidth < 1200 ? "md-size-33" : "";
    },
    setDataStatic(staticInfo) {
      const { chart, data } = cloneDeep(staticInfo);
      this.setInformation(data);
      this.setDataChart(chart);
    },
    setListGeneralInfo(formProps) {
      // let startDateTime = moment(formProps.start).format(formatDateClient);
      let startDateTime = convertTimeByTimezone(
        formProps.start,
        "Etc/UTC",
        formProps.timezone,
        formatDateClient
      );
      formProps.zoom_meeting.startDateTime = startDateTime;
      return scheduleMeetingList(formProps.zoom_meeting);
    },
    setInformation(info) {
      this.information = listCardInformation(info);
    },
    setDataChart(chart) {
      this.present = chart.present.toFixed(2) + "%";
      let absence = (100 - chart.present.toFixed(2)).toFixed(2) + "%";
      this.chartData = {
        labels: [
          this.$t("zoom_meeting.absence") + " " + absence,
          this.$t("zoom_meeting.present") + " " + this.present
        ],
        datasets: [
          {
            backgroundColor: ["#F3DEF7", "#BD79C9"],
            data: [chart.absence, chart.present]
          }
        ]
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.chart-container {
  position: relative;
}
.grow {
  flex-grow: 1;
}
.chart-content {
  display: inline;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 16px));
}
</style>
